module.exports = __webpack_public_path__ + "img/logo-genesis-with-text.0d42a4f9.svg";